import { useHead } from '@unhead/vue'

const SITE_NAME = 'Hai Afară!'

/**
 * Reactively sets Open Graph, Twitter Card, canonical, and meta description tags.
 *
 * @param {() => Object|null} tagsFn - Reactive getter returning:
 *   {
 *     title: string,
 *     url: string,
 *     description?: string,   // plain text, already stripped of HTML
 *     image?: string,         // absolute URL; triggers summary_large_image card type
 *     type?: string,          // og:type, defaults to 'website'
 *   }
 *   Return null/falsy while data is not yet loaded — tags will be cleared.
 */
export function useSeoTags(tagsFn) {
  useHead(() => {
    const tags = tagsFn()
    if (!tags) return {}

    const meta = [
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:type', content: tags.type || 'website' },
      { property: 'og:title', content: tags.title },
      { property: 'og:url', content: tags.url },
      { name: 'twitter:card', content: tags.image ? 'summary_large_image' : 'summary' },
      { name: 'twitter:title', content: tags.title },
    ]

    const link = [{ rel: 'canonical', href: tags.canonical || tags.url }]

    if (tags.description) {
      meta.push(
        { name: 'description', content: tags.description },
        { property: 'og:description', content: tags.description },
        { name: 'twitter:description', content: tags.description },
      )
    }

    if (tags.image) {
      meta.push(
        { property: 'og:image', content: tags.image },
        { name: 'twitter:image', content: tags.image },
      )
    }

    return { meta, link }
  })
}
